import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, forkJoin } from 'rxjs';
import {
    catchError,
    filter,
    switchMap,
    map,
    tap,
    withLatestFrom
} from 'rxjs/operators';
import { ManagementApiService } from '../management-api.service';
import { ManagementStoreService } from '../management-store.service';
import { AddAttributeDialogComponent } from '@emm/shared/dialogs/add-attribute-dialog/add-attribute-dialog.component';
import {AttributesActions} from '@emm/management/store/attributes/attributes.actions';
import {NotificationService} from '@emm/shared/services/notification.service';

@Injectable({
    providedIn: 'root'
})
export class AttributesEffects {

    loadGlobalAttributes$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AttributesActions.loadGlobalAttributes),
            switchMap(() =>
                this.api.getAllGlobalAttributes().pipe(
                    map((attributes) => AttributesActions.loadGlobalAttributesSuccess({ attributes })),
                    catchError(({ error }) => of(AttributesActions.loadGlobalAttributesFailure({ error })))
                )
            )
        )
    );

    load$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AttributesActions.load),
            switchMap(() =>
                forkJoin([this.api.getAllAttributes(), this.api.getAllAttributeTypes()]).pipe(
                    map(([attributes, attributeTypes]) =>
                        AttributesActions.loadSuccess({ attributes, attributeTypes })
                    ),
                    catchError(({ error }) => of(AttributesActions.loadFailure({ error })))
                )
            )
        )
    );

    openAddDialog$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AttributesActions.openAddDialog),
            withLatestFrom(this.store.queryAttributes.attributeTypes$),
            switchMap(([_, attributeTypes]) => {
                const dialogRef = this.dialog.open(AddAttributeDialogComponent, {
                    data: { createAttribute: true, attributeTypes },
                    width: '600px'
                });

                return dialogRef.afterClosed().pipe(
                    filter((result) => result && result === 'submit'),
                    tap(() => {
                        this.notificationService.success('Created successfully');
                    }),
                    map(() =>AttributesActions.load())
                );
            })
        )
    );

    constructor(
        private actions$: Actions,
        private api: ManagementApiService,
        public dialog: MatDialog,
        private notificationService: NotificationService,
        private store: ManagementStoreService
    ) {}

}
